import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { useTakeMealtModel } from "../takeMealtModel"
import { DescriptionColorEnum } from "@/components/YhBox/Types";
export const DataBox = () => {
    const { listExport, totalFood } = useTakeMealtModel();

    const title = <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { listExport() }}
        >导出</Button>
    </>
    return (
        <YhBox title={title} descriptions={totalFood.map(item => ({
            label: item.food,
            value: item.num,
            color: DescriptionColorEnum.green
        }))}>
            <DataTable />
        </YhBox>
    )
}